export default {
    path: '/login',
    name: 'login',
    component : () => import('@/components/admin/login')
}
